<template>
  <div class="pr-5 pl-5">
    <table class="table">
      <thead>
        <tr>
          <th>Comment No.</th>
          <th>Created By</th>
          <th>Date Created</th>
          <th>Comment Details</th>
          <th>Priority</th>
          <th>Status</th>
          <th>Asset Type</th>
          <th>Attachments</th>
          <th>Actions</th>
          <th>Delete</th>
        </tr>
        <tr>
          <td></td>
          <td>
            <input type="text" v-model="searchCreatedBy" placeholder="Search" class="form-control form-control-sm">
          </td>
          <td></td>
          <td></td>
          <td>
            <select class="form-control" v-model="selectedPriority" required>
              <option value="" disabled selected></option>
              <option value="All" selected>All</option>
              <option v-for="(item, index) in priorityFilterSet" :value="item" :key="index">{{item}}</option>
            </select>
          </td>
          <td>
            <select class="form-control form-control-sm" v-model="selectedStatus" required>
              <option value="All" selected>All</option>
              <option v-for="(item, index) in statusFilterSet" :value="item" :key="index">{{item}}</option>
            </select>
          </td><td>
            <select class="form-control form-control-sm" v-model="selectedAssetType" required>
              <option value="All" selected>All</option>
              <option v-for="(item, index) in assetTypeList" :key="index" :value="item.label">{{item.label}}</option>
            </select>
          </td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
      </thead>
      <tbody>
        <template v-if="filteredList.length">
          <tr v-for="item in commentListFinal" :key="item.objectId">
            <td>{{item.objectId}}</td>
            <td>{{item.name}}</td>
            <td>{{item.date}}</td>
            <td>{{item.comment}}</td>
            <td>{{item.priority}}</td>
            <td>{{item.approvalStatus}}</td>
            <td>{{item.assetType}}</td>
            <td>
              <template v-if="item.fileId" class="row">
                  <i>
                    <small>
                      {{(item.fileName.length>=attachmentNameLengthLimit?item.fileName.split(".")[0].substring(0,attachmentNameLengthLimit)+'...'+item.fileName.split(".")[item.fileName.split(".").length-1]:item.fileName)}}
                    </small>
                  </i>
                  <button type="button" v-on:click="downloadFile(item.fileId, 'commentFile')" class="btn btn-light btn-sm mb-xl-2"><i class="fas fa-download"></i></button>
              </template>
            </td>
            <td>
              <a :href="appBaseUrl+item.objectId" v-on:click="goToObject(item.objectId)" target="_blank">
                <button class="btn btn-outline-secondary btn-sm" type="button" ><i class="fa fa-share"></i></button>
              </a>
            </td>
            <td>
              <b-form-checkbox @change="toggleCommentToDelete(item.objectId)"></b-form-checkbox>
            </td>
          </tr>
        </template>
        <template v-else>
          <tr>
            <div class="">
              No data found.
            </div>

          </tr>
        </template>

      </tbody>
    </table>
    <div class="row">
      <div class="col-11">
        <paginate
        v-if="filteredList.length > 0"
        v-model="selectedPageNumber"
        :page-count="numberOfPages"
        :page-range="3"
        :margin-pages="2"
        :click-handler="selectNewPage"
        :prev-text="''"
        :next-text="''"
        :container-class="'pagination pagination-sm'"
        :page-class="'page-item'"
        :page-link-class="'page-link'"
        >
        </paginate>
      </div>
      <div class="col-1">
        <b-button variant="outline-danger" :disabled="commentsToDelete.length==0" v-on:click="deleteComment"><i class="fa fa-trash-alt"></i></b-button>
      </div>
    </div>
    <button type="button" class="btn btn-secondary btn-circle btn-xl bottomright btn-orange" v-on:click="exportReport()" title="Export Report"><i class="fa fa-download"></i></button>
  </div>
</template>

<script>
/*eslint-disable*/
import { baseApiUrl, appBaseUrl } from "../../config.js"
import axios from "axios"
import Paginate from 'vuejs-paginate'

export default {
  name: 'CommentList',
  components: {
    Paginate
  },
  data() {
    return {
      // disciplineFilterSet: ['Design Management','Civil','Road Design','Drainage','Traffic','Utilities','Structures','Geotech','Tunnel','Ventilation','Design & Engineering','GIS','Project Management','Ground Engineering','CAD','ITS Surface','M&E'],
      statusFilterSet: ['Approved','Pending'],
      priorityFilterSet: ['High','Medium','Low'],
      severityFilterSet: ['A', 'B', 'C', 'D'],
      selectedStatus: "All",
      // selectedDiscipline: "All",
      selectedAssetType: "All",
      selectedCommentType: "All",
      selectedPriority: "All",
      selectedSeverity: "All",
      appBaseUrl: appBaseUrl,
      searchCreatedBy: "",
      searchAddressedTo: "",
      attachmentNameLengthLimit: 15,
      // numberOfPages: 0,
      perPageCount: 10,
      selectedPageNumber: 1,
      commentsToDelete: []
    }
  },
  computed: {
    commentList: {
      get() {
        return this.$store.state.mapModule.initialComments
      }
    },
    filteredList: {
      get() {
        var finalList = this.commentList
        // if (this.selectedDiscipline != "All") {
        //   finalList = this.commentList.filter(obj=>obj.discipline == this.selectedDiscipline)
        // }
        if (this.selectedStatus != "All") {
          finalList = finalList.filter(obj=>obj.approvalStatus == this.selectedStatus)
        }
        if (this.selectedAssetType != "All") {
          finalList = finalList.filter(obj=>obj.assetType == this.selectedAssetType)
        }

        if (this.selectedPriority != "All") {
          finalList = finalList.filter(obj=>obj.priority == this.selectedPriority)
        }

        if (this.searchCreatedBy != "") {
          finalList = finalList.filter(list => {
            return list.name.toLowerCase().includes(this.searchCreatedBy.toLowerCase())
          })
        }
        return finalList
      }
    },
    assetTypeList: {
      get() {
        return this.$store.state.mapModule.assetTypeList
      }
    },
    numberOfPages: {
      get() {
        return Math.ceil(this.filteredList.length / this.perPageCount)
      }
    },
    commentListFinal: {
      get() {
        // console.log("("+(this.selectedPageNumber - 1) * this.perPageCount+" , "+ this.selectedPageNumber * this.perPageCount +")");
        // console.log(this.numberOfPages);
        // console.log(this.filteredList);
        const current = this
        if(current.numberOfPages >= current.selectedPageNumber){
          return current.filteredList.slice((current.selectedPageNumber - 1) * current.perPageCount, current.selectedPageNumber * current.perPageCount)
        }
        else{
          console.log(current.selectedPageNumber);
          console.log(current.numberOfPages);
          // current.selectedPageNumber = current.numberOfPages
          current.selectedPageNumber = 1
          return current.filteredList.slice((current.selectedPageNumber - 1) * current.perPageCount, current.selectedPageNumber * current.perPageCount)
        }

      }
    }
  },
  methods: {
    goToObject: function(objectId) {
      sessionStorage.origURL = appBaseUrl+objectId
    },
    downloadFile: function(fileId, type) {
      let formData = new FormData();
      let url = baseApiUrl + "downloadAttachment";
      let config = {
        headers: {
          'content-type': 'application/octet-stream'
        },
        responseType: 'blob'
      }
      formData.append("fileId", fileId);
      formData.append("type", type);
      axios.post(url, formData, config).then((result) => {
        var disposition = result.headers['content-disposition'];
        // fix this matches
        var matches = /=(.*)/.exec(disposition);
        var filename = (matches != null && matches[1] ? matches[1] : '').replace(/"*/g,"");
        // filename = filename.replace(/"*/g,"");
        var type = result.headers['content-type'];
        var link = document.createElement('a');

        document.body.appendChild(link)
        link.style = "display: none"
        var blob = new Blob(
          [result.data],
          {type: result.headers['content-type']}
        );
        var url = window.URL.createObjectURL(blob);
        link.href = url;
        link.download = filename;
        link.click();
        window.URL.revokeObjectURL(url);
        // link.remove();
      });
    },
    selectNewPage: function(pageNumber) {
      const current = this
      current.selectedPageNumber = pageNumber
      console.log(pageNumber);
    },
    exportReport: function() {
      let formData = new FormData();
      let url = baseApiUrl + "exportReport";
      let config = {
        headers: {
          'content-type': 'application/octet-stream'
        },
        responseType: 'blob'
      }
      axios.post(url, formData, config).then((result) => {
        var disposition = result.headers['content-disposition'];
        // fix this matches
        var matches = /=(.*)/.exec(disposition);
        var filename = (matches != null && matches[1] ? matches[1] : '').replace(/"*/g,"");
        // filename = filename.replace(/"*/g,"");
        var type = result.headers['content-type'];
        var link = document.createElement('a');

        document.body.appendChild(link)
        link.style = "display: none"
        var blob = new Blob(
          [result.data],
          {type: result.headers['content-type']}
        );
        var url = window.URL.createObjectURL(blob);
        link.href = url;
        link.download = filename;
        link.click();
        window.URL.revokeObjectURL(url);
      });
    },
    deleteComment: function() {
      // console.log(id);
      const current = this
      var checkDeletion = confirm("Are you sure you would like to delete Comment(s) #" + current.commentsToDelete.toString() + " ?")
      if (checkDeletion) {
        console.log(current.commentsToDelete);
        var data = {
          commentsToDelete: current.commentsToDelete
        }
        var url = baseApiUrl + "deleteComments"
        var config = {
          responseType: 'json'
        }
        axios.post(url, data, config).then(result=>{
          if (result.data.includes('error')) {
            current.$notify({
              group: 'errors',
              title: "Error Deleting Comments",
              type: 'error',
              text: "Some comments have problems being deleted. We will refresh the application shortly.",
              width: 500,
              duration: 1000
            })
          }
          else {
            current.$notify({
              group: 'successNotifications',
              title: "Success Deleting Comments",
              type: 'success',
              text: "Comment deletion successful. We will refresh the application shortly.",
              width: 500,
              duration: 1000
            })
          }
          setTimeout(function() {
            location.reload()
          }, 1200);
        })
      }
    },
    toggleCommentToDelete: function(id) {
      if (this.commentsToDelete.includes(id)) {
        const isElementLocation = (element) => element == id;
        var index = this.commentsToDelete.findIndex(isElementLocation)
        this.commentsToDelete.splice(index,1)
      }
      else {
        this.commentsToDelete.push(id)
      }
    }

  },
  aftermount() {
    console.log("after mount");
  }

}
</script>

<style>
.btn-circle.btn-xl {
  width: 70px;
  height: 70px;
  padding: 10px 16px;
  border-radius: 35px;
  font-size: 24px;
  line-height: 1.33;
}

.btn-circle {
  width: 30px;
  height: 30px;
  padding: 6px 0px;
  border-radius: 15px;
  text-align: center;
  font-size: 12px;
  line-height: 1.42857;
}
.bottomright {
  position: absolute;
  bottom: 16px;
  right: 16px;
}

.btn-orange {
  background-color: #E66200 !important;
  border-color: #E66200 !important;
}
.btn-orange:focus {
  -webkit-box-shadow: 0 0 0 0.2rem rgba(230, 98, 0, 0.25) !important;
  box-shadow: 0 0 0 0.2rem rgba(230, 98, 0, 0.25) !important;
}
.page-item.active .page-link {
  color: #fff !important;
  background-color: #E66200 !important;
  border-color: #E66200 !important;
}
.page-link {
  color: #E66200 !important;
}
.page-link:focus {
  -webkit-box-shadow: 0 0 0 0.2rem rgba(230, 98, 0, 0.25) !important;
  box-shadow: 0 0 0 0.2rem rgba(230, 98, 0, 0.25) !important;
}
</style>
